import {FormikErrors} from 'formik';
import {get, set} from 'lodash-es';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';
import {hasWrapper} from '../CreateRecommend/RecommendSourceDestination/utils';
import {
  validateMandateField,
  validateTextField,
} from '../CreateRecommend/RecommendSourceDestination/validators';
import {planFeesFieldType} from '../CreateRecommend/PlanFees';

export const setUpNewValidator = (
  values: recommendFieldsType,
  errors: FormikErrors<recommendFieldsType>
): FormikErrors<recommendFieldsType> => {
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  const setUpNewValues = values.setUpNew;
  if (!setUpNewValues) {
    errors.setUpNew = 'Fill in fields';
    return errors;
  }

  newPlanValidator({
    values,
    errors,
    formikKeyPrefix: `setUpNew.newPlan`,
    context: OVRecommendActionEnum.SET_UP_NEW,
    isLowesPension: values.isLowesPension,
    isTransactBond: values.isTransactBond,
    isMinor: values.isMinor,
  });
  return errors;
};

type subplanValidatorArgs = {
  values: recommendFieldsType;
  errors: FormikErrors<recommendFieldsType>;
  formikKeyPrefix: string;
  context:
    | OVRecommendActionEnum.CONTRIBUTE
    | OVRecommendActionEnum.TRANSFER
    | OVRecommendActionEnum.SET_UP_NEW;
};
export const newSubplanValidator = ({
  errors,
  values,
  formikKeyPrefix,
  context,
}: subplanValidatorArgs): void => {
  validateTextField(
    get(values, `${formikKeyPrefix}.planProvider`),
    `${formikKeyPrefix}.planProvider`,
    errors
  );

  validateMandateField(
    get(values, `${formikKeyPrefix}.model`),
    `${formikKeyPrefix}.model`,
    errors
  );
  planFeeValidator({values, errors, formikKeyPrefix});
};

export const planFeeValidator = ({
  values,
  formikKeyPrefix,
  errors,
}: {
  values: recommendFieldsType;
  errors: FormikErrors<recommendFieldsType>;
  formikKeyPrefix: string;
}): void => {
  const planFees = get(
    values,
    `${formikKeyPrefix}.planFees`
  ) as unknown as planFeesFieldType | null;
  if (!planFees) {
    set(errors, `${formikKeyPrefix}.planFees`, 'Please set plan fees');
    return;
  }
  if (planFees.DFMFeeRequired && !planFees.DFMFeeId) {
    set(errors, `${formikKeyPrefix}.planFees.DFMFeeId`, 'Required');
  }
  if (planFees.productFeeRequired && !planFees.productFeeId) {
    set(errors, `${formikKeyPrefix}.planFees.productFeeId`, 'Required');
  }
  if (planFees.FPFeeRequired && !planFees.FPFeeId) {
    set(errors, `${formikKeyPrefix}.planFees.FPFeeId`, 'Required');
  }
};

type newPlanValidatorArgs = {
  values: recommendFieldsType;
  errors: FormikErrors<recommendFieldsType>;
  formikKeyPrefix: string;
  context:
    | OVRecommendActionEnum.CONTRIBUTE
    | OVRecommendActionEnum.TRANSFER
    | OVRecommendActionEnum.SET_UP_NEW;
  isSaltusProvider?: boolean;
  isLowesPension?: boolean;
  isTransactBond?: boolean;
  isMinor?: boolean;
};
export const newPlanValidator = ({
  values,
  errors,
  formikKeyPrefix,
  context,
  // TODO: check if non saltus providers need subplan validation outside contribution
  // for now let's keep the current behaviour
  isSaltusProvider = true,
  isLowesPension = false,
  isTransactBond = false,
  isMinor,
}: newPlanValidatorArgs): void => {
  validateTextField(
    get(values, `${formikKeyPrefix}.planType`),
    `${formikKeyPrefix}.planType`,
    errors
  );
  validateTextField(
    get(values, `${formikKeyPrefix}.planProvider`),
    `${formikKeyPrefix}.planProvider`,
    errors
  );
  if (isMinor && !get(values, `${formikKeyPrefix}.parentGuardianId`)) {
    set(errors, `${formikKeyPrefix}.parentGuardianId`, 'Required');
  }
  planFeeValidator({values, formikKeyPrefix, errors});
  // if (!get(values, `${formikErrorKeyPrefix}.contactId`)) {
  //   set(errors, `${formikErrorKeyPrefix}.contactId`, 'Required');
  // }

  if (hasWrapper(values.mainPlanType)) {
    if (!isSaltusProvider || isLowesPension || isTransactBond) {
      /**
       * Non Saltus providers may or may not have subplans
       */
      if (isLowesPension || isTransactBond) {
        /**
         * These wrappers are set up without subplans, so the mandate is picked on
         * the parent. Mirrors where NewPlanForm renders the mandate selector.
         */
        validateMandateField(
          get(values, `${formikKeyPrefix}.model`),
          `${formikKeyPrefix}.model`,
          errors
        );
      }
      return;
    }
    const subplan0Checked = get(values, `${formikKeyPrefix}.subplan0.checked`, false);
    const subplan1Checked = get(values, `${formikKeyPrefix}.subplan1.checked`, false);

    if (subplan0Checked === false && subplan1Checked === false) {
      set(errors, `${context}.newPlan`, 'At least one subplan must be selected');
    }

    if (subplan0Checked) {
      newSubplanValidator({
        errors,
        formikKeyPrefix: `${formikKeyPrefix}.subplan0`,
        values,
        context,
      });
    }

    if (subplan1Checked) {
      newSubplanValidator({
        errors,
        formikKeyPrefix: `${formikKeyPrefix}.subplan1`,
        values,
        context,
      });
    }
  } else {
    validateMandateField(
      get(values, `${formikKeyPrefix}.model`),
      `${formikKeyPrefix}.model`,
      errors
    );
  }
};
